<template>
    <div class="status-reports" :class="state === 'invalid' ? 'is-error' : ''">
        <div
            class="status-reports__icon-wrapper"
            :class="{ center: center }"
            v-tooltip="{
                content: !active ? 'Kasa oznaczona jako nieaktywna' : null
            }"
        >
            <a-icon
                :class="icon.iconClass"
                :icon="icon.icon"
                style="width: 28px; height: 28px"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        state: {
            type: String,
            required: true
        },
        active: {
            type: Boolean,
            default: false
        },
        center: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        icon() {
            let icon

            if (this.state === 'valid' && this.active) {
                icon = {
                    icon: 'Ok',
                    iconClass: 'status-icon-ok'
                }
            } else if (this.state === 'invalid' && this.active) {
                icon = {
                    icon: 'ErrorCircle',
                    iconClass: 'status-icon-error'
                }
            } else {
                icon = {
                    icon: 'CircleGray',
                    iconClass: ''
                }
            }
            return icon
        }
    }
}
</script>
